import {
  VIA,
  TRACE,
  PKG_TOUCHSTONE,
  PASSIVE,
  PASSIVE_TOUCHSTONE,
  PASSIVE_SPICE,
  CONNECTOR_TOUCHSTONE,
  CABLE_TOUCHSTONE,
  IBIS_AMI,
  PCB_TOUCHSTONE,
  IBIS, SPICE, BUFFER,
  EXTRACTION_OPTIONS,
  HFSS_OPTIONS,
  SIWAVE_OPTIONS,
  ADS_OPTIONS,
  EYE_MASK,
  GENERIC_TOUCHSTONE,
  GENERIC_LIBRARY,
  LEQ_RESPONSE,
  BUFFER_SPICE,
  USER_DEFINED_NETLIST,
  REFERENCE_LINE,
  CHANNEL_MODEL,
  CPHY_EYE_MASK
} from '../../../constants/libraryConstants';
import {
  MY_LIBRARY,
  LIBRARY,
  PROJECTS,
  TRASH,
  LIBRARY_OPEN
} from '@/constants/treeConstants';
import {
  ADS_OPTIONS_INDEX,
  BUFFER_INDEX,
  BUFFER_SPICE_INDEX,
  CABLE_INDEX,
  CHANNEL_MODEL_INDEX,
  CONNECTOR_INDEX,
  EXTRACTION_OPTIONS_INDEX,
  EYE_MASK_INDEX,
  GENERIC_INDEX,
  GENERIC_SPICE_INDEX,
  GENERIC_TOUCHSTONE_INDEX,
  HFSS_OPTIONS_INDEX,
  IBIS_AMI_INDEX,
  IBIS_INDEX,
  LEQ_RESPONSE_INDEX,
  PASSIVE_INDEX,
  PASSIVE_SPICE_INDEX,
  PASSIVE_TOUCHSTONE_INDEX,
  PCB_INDEX,
  PKG_INDEX,
  REFERENCE_LINES_INDEX,
  SIWAVE_OPTIONS_INDEX,
  TRACE_INDEX,
  USER_DEFINED_NETLIST_INDEX,
  VIA_INDEX
} from '../library';

export function treeItem({ name, key, dataType, ...restProps }) {
  this.name = name;
  this.key = key;
  this.dataType = dataType;
  this.children = [];
  Object.keys(restProps).map(key => this[key] = restProps[key])
};

export function getDefaultTreeItems() {
  return [{
    name: 'Library',
    key: LIBRARY,
    dataType: MY_LIBRARY,
    nodeClass: 'expand-icon-large',
    children: [
      {
        name: 'Trace Template',
        key: TRACE,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      }, {
        name: 'Via Template',
        key: VIA,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      },
      {
        name: 'Passive Model',
        key: PASSIVE,
        dataType: LIBRARY_OPEN,
        nodeClass: 'expand-icon-middle',
        children: [
          { name: 'Touchstone', key: PASSIVE_TOUCHSTONE },
          { name: 'SPICE', key: PASSIVE_SPICE }
        ].map(d => new treeItem({ name: d.name, key: d.key, dataType: LIBRARY }))
      },
      {
        name: 'Buffer Model',
        key: BUFFER,
        dataType: LIBRARY_OPEN,
        nodeClass: 'expand-icon-middle',
        children: [
          { name: 'IBIS AMI', key: IBIS_AMI },
          { name: 'IBIS', key: IBIS },
          { name: 'SPICE', key: BUFFER_SPICE },
          /*  { name: 'SPICE Netlist', key: SPICE, } */
        ].map(d => new treeItem({ name: d.name, key: d.key, dataType: LIBRARY }))
      },
      {
        name: 'Extraction Options',
        key: EXTRACTION_OPTIONS,
        dataType: LIBRARY_OPEN,
        nodeClass: 'expand-icon-middle',
        children: [
          { name: 'HFSS', key: HFSS_OPTIONS },
          { name: "SIwave", key: SIWAVE_OPTIONS }
        ].map(d => new treeItem({ name: d.name, key: d.key, dataType: LIBRARY }))
      },
      {
        name: 'ADS Options',
        key: ADS_OPTIONS,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      },
      {
        name: 'Eye Mask',
        key: EYE_MASK,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      },
      {
        name: 'Channel Model',
        key: CHANNEL_MODEL,
        dataType: LIBRARY_OPEN,
        nodeClass: 'expand-icon-middle',
        children: [
          { name: 'Package Model', key: PKG_TOUCHSTONE },
          { name: 'PCB Model', key: PCB_TOUCHSTONE },
          { name: 'Connector Model', key: CONNECTOR_TOUCHSTONE },
          { name: 'Cable Model', key: CABLE_TOUCHSTONE },
        ].map(d => new treeItem({ name: d.name, key: d.key, dataType: LIBRARY }))
      },
      {
        name: 'Generic Model',
        key: GENERIC_LIBRARY,
        dataType: LIBRARY_OPEN,
        nodeClass: 'expand-icon-middle',
        children: [
          { name: 'Touchstone', key: GENERIC_TOUCHSTONE, },
          { name: 'SPICE', key: SPICE }
        ].map(d => new treeItem({ name: d.name, key: d.key, dataType: LIBRARY }))
      },
      {
        name: 'LEQ Response',
        key: LEQ_RESPONSE,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      },
      {
        name: 'User Defined Netlist',
        key: USER_DEFINED_NETLIST,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      },
      {
        name: 'Reference Line',
        key: REFERENCE_LINE,
        dataType: LIBRARY,
        nodeClass: 'expand-icon-middle',
        children: []
      }
    ]
  }, {
    name: 'Project',
    key: PROJECTS,
    dataType: PROJECTS,
    nodeClass: 'expand-icon-large',
    children: []
  }, {
    name: 'Trash',
    key: TRASH,
    dataType: TRASH,
    nodeClass: 'expand-icon-large'
  }];
};

export function getTreeItemsLoadObj() {
  return {
    [TRACE]: {
      keys: [TRACE],
      indexs: [TRACE_INDEX],
      initFunction: 'getPreLayoutLibraryArray'
    },
    [VIA]: {
      keys: [VIA],
      indexs: [VIA_INDEX],
      initFunction: 'getPreLayoutLibraryArray'
    },
    [PASSIVE_TOUCHSTONE]: {
      keys: [PASSIVE_TOUCHSTONE],
      indexs: [PASSIVE_INDEX, PASSIVE_TOUCHSTONE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [PASSIVE_SPICE]: {
      keys: [PASSIVE_SPICE],
      indexs: [PASSIVE_INDEX, PASSIVE_SPICE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [PKG_TOUCHSTONE]: {
      keys: [PKG_TOUCHSTONE],
      indexs: [CHANNEL_MODEL_INDEX, PKG_INDEX],
      initFunction: 'getLibraryArray'
    },
    [PCB_TOUCHSTONE]: {
      keys: [PCB_TOUCHSTONE],
      indexs: [CHANNEL_MODEL_INDEX, PCB_INDEX],
      initFunction: 'getLibraryArray'
    },
    [CONNECTOR_TOUCHSTONE]: {
      keys: [CONNECTOR_TOUCHSTONE],
      indexs: [CHANNEL_MODEL_INDEX, CONNECTOR_INDEX],
      initFunction: 'getLibraryArray'
    },
    [CABLE_TOUCHSTONE]: {
      keys: [CABLE_TOUCHSTONE],
      indexs: [CHANNEL_MODEL_INDEX, CABLE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [IBIS_AMI]: {
      keys: [IBIS_AMI],
      indexs: [BUFFER_INDEX, IBIS_AMI_INDEX],
      initFunction: 'getLibraryArray'
    },
    [IBIS]: {
      keys: [IBIS],
      indexs: [BUFFER_INDEX, IBIS_INDEX],
      initFunction: 'getLibraryArray'
    },
    [BUFFER_SPICE]: {
      keys: [BUFFER_SPICE],
      indexs: [BUFFER_INDEX, BUFFER_SPICE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [HFSS_OPTIONS]: {
      keys: [HFSS_OPTIONS],
      indexs: [EXTRACTION_OPTIONS_INDEX, HFSS_OPTIONS_INDEX],
      initFunction: 'getLibraryArray'
    },
    [SIWAVE_OPTIONS]: {
      keys: [SIWAVE_OPTIONS],
      indexs: [EXTRACTION_OPTIONS_INDEX, SIWAVE_OPTIONS_INDEX],
      initFunction: 'getLibraryArray'
    },
    [ADS_OPTIONS]: {
      keys: [ADS_OPTIONS],
      indexs: [ADS_OPTIONS_INDEX],
      initFunction: 'getLibraryArray'
    },
    [EYE_MASK]: {
      keys: [EYE_MASK, CPHY_EYE_MASK],
      indexs: [EYE_MASK_INDEX],
      initFunction: 'getLibraryArray'
    },
    [GENERIC_TOUCHSTONE]: {
      keys: [GENERIC_TOUCHSTONE],
      indexs: [GENERIC_INDEX, GENERIC_TOUCHSTONE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [SPICE]: {
      keys: [SPICE],
      indexs: [GENERIC_INDEX, GENERIC_SPICE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [LEQ_RESPONSE]: {
      keys: [LEQ_RESPONSE],
      indexs: [LEQ_RESPONSE_INDEX],
      initFunction: 'getLibraryArray'
    },
    [USER_DEFINED_NETLIST]: {
      keys: [USER_DEFINED_NETLIST],
      indexs: [USER_DEFINED_NETLIST_INDEX],
      initFunction: 'getLibraryArray'
    },
    [REFERENCE_LINE]: {
      keys: [REFERENCE_LINE],
      indexs: [REFERENCE_LINES_INDEX],
      initFunction: 'getLibraryArray'
    }
  }
}

export const defaultTreeItems = getDefaultTreeItems();